export default __webpack_public_path__ + "static/media/claudio-prc.d4b9663b.jpg";